import React from "react";
import { PaymentScheduleResponse } from "@/api";

export interface PaymentScheduleViewProps {
  finalAmount: number;
  schedules: PaymentScheduleResponse[];
}

export default function PaymentScheduleView({
  finalAmount,
  schedules = [],
}: PaymentScheduleViewProps) {
  return (
    <section className="rounded-xl border bg-white p-6">

      {schedules.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b">
                <th className="px-4 py-3 text-left text-sm font-medium">
                  #
                </th>

                <th className="px-4 py-3 text-left text-sm font-medium">
                  Payment
                </th>

                <th className="px-4 py-3 text-left text-sm font-medium">
                  Percentage
                </th>

                <th className="px-4 py-3 text-right text-sm font-medium">
                  Amount
                </th>

                <th className="px-4 py-3 text-left text-sm font-medium">
                  Due Date
                </th>

                <th className="px-4 py-3 text-left text-sm font-medium">
                  Status
                </th>
              </tr>
            </thead>

            <tbody>
              {schedules.map(
                (schedule, index) => (
                  <tr
                    key={
                      schedule.id ||
                      `${schedule.sequence}-${index}`
                    }
                    className="border-b last:border-0"
                  >
                    <td className="px-4 py-3">
                      {schedule.sequence ??
                        index + 1}
                    </td>

                    <td className="px-4 py-3">
                      {schedule.label ??
                        `Payment ${index + 1}`}
                    </td>

                    <td className="px-4 py-3">
                      {`${schedule.percentage} %`}
                    </td>

                    <td className="px-4 py-3 text-right">
                      ₹
                      {Number(
                        schedule.amount ?? 0,
                      ).toFixed(2)}
                    </td>

                    <td className="px-4 py-3">
                      {schedule.due_date
                        ? new Date(
                            schedule.due_date,
                          ).toLocaleDateString()
                        : "-"}
                    </td>

                    <td className="px-4 py-3">
                      {schedule.status?.toLocaleUpperCase() ?? "-"}
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="rounded-lg border border-dashed p-6 text-center text-sm text-gray-500">
          No payment schedule configured.
        </div>
      )}

      <div className="mt-4 text-right text-sm text-gray-500">
        Invoice Total: ₹
        {Number(finalAmount ?? 0).toFixed(2)}
      </div>
    </section>
  );
}